<template>
  <div id="contenedor-main-contrato-directorio">
    <!-- ToolBar -->
    <tool-bar
      v-if="!$apollo.loading"
      class="my-3"
      v-on:nuevoDirectorio="registrarNuevoDirectorio">
    </tool-bar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody">
    </v-skeleton-loader>
    <template v-if="listado.length < 1">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay registros. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <v-card
        flat>
        <v-card-text>
          <listado
            :listado="listado">
          </listado>
        </v-card-text>
      </v-card>
    </template>
    <!-- Agregar contrato directorio -->
    <v-dialog
      v-model="mostrarRegistrarDirectorio"
      persistent
      width="550">
      <agregar-directorio
        :id-contrato="$route.params.idContrato"
        v-on:cerrar="cerrar">
      </agregar-directorio>
    </v-dialog>
    <!-- Editar directorio -->
    <v-dialog
      v-if="esteDirectorio"
      v-model="mostrarActualizarDirectorio"
      persistent
      width="550">
      <editar-directorio
        :directorio-editar="esteDirectorio"
        v-on:cerrar="cerrar">
      </editar-directorio>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_DIRECTORIO from '@/graphql/querys/administracion/contratos/contrato/directorio/contratoDirectorio.gql';
import ToolBar from './ToolBar.vue';
import AgregarDirectorio from '@/components/administracion/contratos/contrato/directorio/Agregar.vue';
import EditarDirectorio from '@/components/administracion/contratos/contrato/directorio/Editar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoDirectorio',
  components: {
    ToolBar,
    AgregarDirectorio,
    EditarDirectorio,
    Listado,
  },
  data() {
    return {
      mostrarRegistrarDirectorio: false,
      mostrarActualizarDirectorio: false,
      esteDirectorio: null,
    };
  },
  apollo: {
    contratoDirectorio: {
      query: CONTRATO_DIRECTORIO,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  mounted() {
    eventBus.$on('editar-directorio-contrato', (directorio) => {
      this.esteDirectorio = directorio;
      this.mostrarActualizarDirectorio = true;
    });
    eventBus.$on('eliminar-directorio-contrato', (directorio) => {
      this.esteDirectorio = directorio;
    });
  },
  methods: {
    registrarNuevoDirectorio() {
      this.mostrarRegistrarDirectorio = true;
    },
    cerrar() {
      this.mostrarRegistrarDirectorio = false;
      this.mostrarActualizarDirectorio = false;
      this.esteDirectorio = null;
    },
  },
  computed: {
    listado() {
      if (!this.contratoDirectorio) return [];
      return this.contratoDirectorio
        .slice()
        .sort((a, b) => (`${a.tipo}`).localeCompare(b.tipo));
    },
  },
};
</script>

<style lang="scss">

</style>
